var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rightText != '失效')?_c('div',{staticClass:"overduePrescription1"},[_c('div',[_vm._v(_vm._s(_vm.leftText))]),_c('div',[_vm._v(_vm._s(_vm.rightText))])]):_c('div',{staticClass:"fail"},[_c('div',[_vm._v("失效")])])}
var staticRenderFns = []

export { render, staticRenderFns }